<main class="page-wrapper">
  <!-- Header-->
  <app-header id="top"></app-header>

  <!-- Page container-->
  <div class="container-fluid mt-5 pt-5 p-0">
    @if(!hasAccess){
      <!-- Overlay de blocage -->
      <div class="content-blocked-overlay">
          <div class="content-blocked text-center py-5">
              <div class="container">
                  <i class="fi-lock display-4 text-primary mb-4"></i>
                  <h2>Contenu Bloqué</h2>
                  <p class="lead mb-4">Pour accéder aux offres d'emploi, vous devez avoir une licence valide.</p>
                  <button class="btn btn-primary" (click)="openLicenceModal()">
                      <i class="fi-plus me-2"></i>Ajouter une licence
                  </button>
              </div>
          </div>
      </div>
      }
    <div [class.blurred-content]="!hasAccess" class="row g-0 mt-n3">

      <!-- Filters sidebar (Offcanvas on mobile)-->
      <aside class="col-lg-4 col-xl-3 border-top-lg border-end-lg shadow-sm px-3 px-xl-4 px-xxl-5 pt-lg-2">
        <div class="offcanvas-lg offcanvas-start pe-lg-3" id="filters-sidebar">
          <div class="offcanvas-header d-flex d-lg-none align-items-center">
            <h2 class="h5 mb-0">Filtres</h2>
            <button class="btn-close" type="button" data-bs-dismiss="offcanvas" (click)="SidebarHide()"></button>
          </div>
          <!-- Search form-->
          <div class="offcanvas-header d-block border-bottom pt-0 pt-lg-4 px-lg-0">
            <div class="input-group">
              <span class="input-group-text text-muted">
                <i class="fi-search"></i>
              </span>
              <input class="form-control" type="text" placeholder="Rechercher..." [(ngModel)]="term"
                (ngModelChange)="onSearchInput($event)">
            </div>
          </div>
          <!-- Nav tabs-->
          <div class="offcanvas-header d-block border-bottom py-lg-4 py-3 px-lg-0">
            <ul ngbNav #nav="ngbNav" [activeId]="2" class="nav nav-pills">
              <li [ngbNavItem]="2" class="nav-item">
                <a ngbNavLink>
                  <i class="fi-filter-alt-horizontal me-2"></i>Filtres
                </a>

                <ng-template ngbNavContent>
                  <!-- Filters-->
                  <!-- Toggle for pharmacies -->
                  <div *ngIf="currentDataType === 'pharmacies'">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="gardeToggle" [(ngModel)]="filterGarde"
                        (ngModelChange)="onGardeToggleChange()">
                      <label class="form-check-label" for="gardeToggle">
                        Afficher uniquement les pharmacies de garde
                      </label>
                    </div>
                  </div>
                  <div class="pb-4 mb-2">
                    <h3 class="h6">Localisation</h3>
                    <select class="form-select mb-2" #locationSelect (change)="onLocationChange(locationSelect.value)">
                      <option value="">Choisir une ville</option>
                      @for(city of cities;track city){
                      <option [value]="city">{{city}}</option>
                      }
                    </select>
                    <select class="form-select" #districtSelect (change)="onDistrictChange(districtSelect.value)"
                      [disabled]="!selectedLocation">
                      <option value="">Choisir un quartier</option>
                      @for(district of availableDistricts;track district){
                      <option [value]="district">{{district}}</option>
                      }
                    </select>
                  </div>
                  <div class="border-top py-4">
                    <button class="btn btn-outline-primary rounded-pill" type="button"><i
                        class="fi-rotate-right me-2"></i>Réinitialiser les filtres</button>
                  </div>
                </ng-template>
              </li>
            </ul>
          </div>
          <div class="offcanvas-body py-lg-4">
            <!-- Tabs content-->
            <div class="tab-content">
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </div>
        </div>
      </aside>
      <!-- Page content-->
      <div class="col-lg-8 col-xl-9 position-relative overflow-hidden pb-5 pt-4 px-3 px-xl-4 px-xxl-5">
        <!-- Map popup-->
        <div class="map-popup invisible" id="map">
          <button class="btn btn-icon btn-light btn-sm shadow-sm rounded-circle" type="button"
            (click)="closeMapModel()">
            <i class="fi-x fs-xs"></i>
          </button>

          <google-map [options]="mapOptions" class="interactive-map rounded-3" style="height: 100%">

            <map-marker *ngFor="let marker of markers" [position]="marker.position" [title]="marker.title"
              [label]="marker.label">
            </map-marker>

          </google-map>
        </div>
        <!-- Breadcrumb-->
        <app-breadcrumbs [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
        <!-- Bannière publicitaire -->
        <div class="advertisement-banner mb-4" *ngIf="advertisements.length > 0">
          <ngb-carousel [interval]="5000" [showNavigationArrows]="true" [showNavigationIndicators]="true">
            @for(ad of advertisements;track ad.id){
            <ng-template ngbSlide>
              <div class="ad-slide position-relative" style="height: 300px;">
                <!-- Image de fond -->
                <a [href]="ad.path" target="_blank">
                <img [src]="ad.path" 
                     [alt]="ad.libelle" 
                     class="w-100 h-100" 
                     style="object-fit: cover;">
                    </a>
                <!-- Contenu flottant -->
                <!--<div class="ad-content position-absolute bottom-0 start-0 p-4 text-white" 
                     style="background: linear-gradient(transparent, rgba(0,0,0,0.8));">
                  <h3 class="mb-2">{{ad.libelle}}</h3>
                  <p class="mb-0">{{ad.description}}</p>
                </div>-->

                <!-- Boutons de réseaux sociaux -->
                <div class="social-buttons position-absolute bottom-0 end-0 p-4">
                  @if(ad.lien_whatsapp){
                  <a [href]="ad.lien_whatsapp" 
                     target="_blank" 
                     class="btn btn-success rounded-circle me-2" 
                     style="width: 45px; height: 45px;">
                    <i class="fi-whatsapp fs-5 d-flex align-items-center justify-content-center h-100"></i>
                  </a>
                  }
                  @if(ad.lien_facebook){
                  <a [href]="ad.lien_facebook" 
                     target="_blank" 
                     class="btn btn-primary rounded-circle" 
                     style="width: 45px; height: 45px;">
                    <i class="fi-facebook fs-5 d-flex align-items-center justify-content-center h-100"></i>
                  </a>
                  }
                </div>
              </div>
            </ng-template>
            }
          </ngb-carousel>
        </div>
        <!-- Remplacer le titre statique par un titre dynamique -->
        <div class="d-sm-flex align-items-center justify-content-between pb-3 pb-sm-4">
          <h1 class="h2 mb-sm-0">{{getSearchTitle()}}</h1>
          <a class="d-inline-block fw-bold text-decoration-none py-1" href="javascript:void(0);"
            data-bs-toggle-class="invisible" data-bs-target="#map" (click)="openMapModal()">
            <i class="fi-map me-2"></i>Voir sur la carte
          </a>
        </div>
        <!-- Sorting-->
        <div class="d-flex flex-sm-row flex-column align-items-sm-center align-items-stretch my-2">
          <hr class="d-none d-sm-block w-100 mx-4">
          <div class="d-none d-sm-flex align-items-center flex-shrink-0 text-muted"><i
              class="fi-check-circle me-2"></i><span class="fs-sm mt-n1">{{dataCount}} résultats</span></div>
        </div>
        <!-- Loading indicator -->
        <div *ngIf="isLoading" class="text-center my-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Chargement...</span>
          </div>
        </div>

        <!-- Error message -->
        <div *ngIf="error" class="alert alert-danger" role="alert">
          {{ error }}
        </div>

        <!-- Remplacer la section des filtres -->
        <div class="filters-section mb-4">
          <!-- Domaines -->
          <div class="mb-4">
            <select class="form-select" #domainSelect (change)="onDomainChange(domainSelect.value)">
              <option value="">Tous les domaines</option>
              @for(domain of domains;track domain.id){
              <option [value]="domain.id">{{domain.libelle}}</option>
              }
            </select>
          </div>

          <!-- Affichage des secteurs en grille si un domaine est sélectionné -->
          @if(selectedDomain && sectors.length > 0){
          <div class="sectors-grid mb-4">
            <h5 class="mb-3">Secteurs</h5>
            <div class="row g-3">
              @for(sector of sectors;track sector.id){
              <div class="col-md-2 col-sm-4 col-6">
                <div class="sector-card card h-100 border-0 shadow-sm cursor-pointer" 
                     [class.active]="selectedSector === sector.id"
                     (click)="onSectorChange(sector.id.toString())">
                  <div class="card-body text-center p-3">
                    <i class="fi-building-house mb-2 d-block fs-3"></i>
                    <h6 class="card-title mb-0 fs-sm">{{sector.libelle}}</h6>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
          }

          <!-- Affichage des sous-secteurs en grille si un secteur est sélectionné -->
          @if(selectedSector && subSectors.length > 0){
          <div class="subsectors-grid mb-4">
            <h5 class="mb-3">Sous-secteurs</h5>
            <div class="row g-3">
              @for(subSector of subSectors;track subSector.id){
              <div class="col-md-2 col-sm-4 col-6">
                <div class="sector-card card h-100 border-0 shadow-sm cursor-pointer"
                     [class.active]="selectedSubSector === subSector.id"
                     (click)="onSubSectorChange(subSector.id.toString())">
                  <div class="card-body text-center p-3">
                    <i class="fi-home mb-2 d-block fs-3"></i>
                    <h6 class="card-title mb-0 fs-sm">{{subSector.libelle}}</h6>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
          }
        </div>

        <!-- Liste des entreprises -->
        <div class="row g-4 mb-4">
          @for(enterprise of enterprises;track enterprise.id){
          <div class="col-sm-6 col-xl-4">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-img-top position-relative">
                <img [src]="enterprise.path" class="w-100" [alt]="enterprise.nom">
              </div>
              <div class="card-body">
                <h5 style="color:#fd390e!important;" class="text-white mb-0">{{enterprise.nom}}</h5>
                <p class="card-text">{{enterprise.adresse}}</p>
                <p class="card-text">{{enterprise.region}}</p>
                <div class="d-flex align-items-center">
                  <i class="fi-map-pin me-2"></i>
                  <span *ngIf="enterprise.distance">{{enterprise.distance}} km</span>
                  <span *ngIf="!enterprise.distance">Distance non disponible</span>
                </div>
                <div class="d-flex align-items-center mt-2">
                  <i class="fi-phone me-2"></i>
                  <span>{{enterprise.telephone}}</span>
                </div>
              </div>
            </div>
          </div>
          }
        </div>

        <!-- Load more button -->
        <div class="text-center mt-4">
          <button class="btn btn-primary" (click)="loadMore()" [disabled]="isLoadingMore" *ngIf="hasMoreData">
            <span *ngIf="!isLoadingMore">Charger plus</span>
            <span *ngIf="isLoadingMore" class="spinner-border spinner-border-sm" role="status"></span>
          </button>
        </div>
      </div>
    </div>
  </div>

</main>

<!-- Footer-->
<app-footer></app-footer>

<!-- Filters sidebar toggle button (mobile)-->
<button class="btn btn-primary btn-sm w-100 rounded-0 fixed-bottom d-lg-none" type="button" data-bs-toggle="offcanvas"
  data-bs-target="#filters-sidebar" (click)="FilterSidebar()"><i class="fi-filter me-2"></i>Filters</button>
<div class="vertical-overlay" (click)="SidebarHide()"></div>

@if(!hasAccess){
<div class="content-blocked text-center py-5">
  <div class="container">
    <i class="fi-lock display-4 text-primary mb-4"></i>
    <h2>Contenu Bloqué</h2>
    <p class="lead mb-4">Pour accéder à ce contenu, vous devez avoir une licence valide.</p>
    <button class="btn btn-primary" (click)="openLicenceModal()">
      <i class="fi-plus me-2"></i>Ajouter une licence
    </button>
  </div>
</div>
}@else{
<!-- Contenu existant -->
}